import DataReportBlock from '../../reporter/report/DataReportBlock';
import logger from '../../log';
import xhrPromise from '../utils/xhrPromise';
import {
  Body,
  ReportBody,
  RequestReport,
  isValidSize,
  maybeStripPayload
} from './sendBeaconReport';
import { LogReporterMessage } from './report/interfaces';
import { Report } from '../../reporter/report/Report';
import { ReporterState } from '../../state/LocalState';

const log = logger.getLogger(__filename);
const MAX_SIZE = 1024 * 1024;

export interface Reporter {
  state: ReporterState;
}
type RSDrb = Record<string, DataReportBlock<unknown>>;

const sendReport = async (
  reporter: Reporter,
  request: RequestReport,
  isFinal?: boolean
): Promise<boolean> => {
  maybeFilterReport(request);
  return xhrPromise({ ...request, async: !isFinal })
    .then(() => {
      log.debug('report', request.body);
      return true;
    })
    .catch(e => {
      if (e) {
        if (e.status == 401 || e.status == 403) {
          reporter.state.isReportingDisabled = true;
          reporter.state.reportStatus = e.status;
        }
        const text = e.statusText ? ` '${e.statusText}'` : '';
        log.error(`report failed ${e.status}${text}`);
        return false;
      }
      log.debug('report failed Error:', e, ', report:', request.body);
      return false;
    });
};

export const getSizes = (request: RequestReport): LogReporterMessage => {
  const sizes: string[] = [];
  if (request && request.body && request.body.record) {
    const record = request.body.record as unknown as RSDrb;
    Object.keys(record).forEach(key => {
      if (record[key] && record[key].data && record[key].data.length > 0) {
        sizes.push(`${key} size ${record[key].data.length}`);
      }
    });
  }
  return {
    data: {
      count: 1,
      last: 0,
      msg: sizes,
      ts: Date.now()
    },
    level: 'TRACE',
    type: 'sendReport'
  };
};

export const mergeSizes = (
  request: RequestReport,
  message: LogReporterMessage
): void => {
  //const rec = body && (body as ReportBody).record;
  const rec = request.body && (request.body as ReportBody).record;
  if (rec) {
    const record = rec as Report;
    if (!record.log) {
      record.log = { data: [] };
    }
    if (!record.log.data) {
      record.log.data = [];
    }
    record.log.data.push(message);
  }
};

export const maybeFilterReport = (request: RequestReport): void => {
  const asJson = JSON.stringify(request && request.body);
  if (!asJson || isValidSize(asJson, MAX_SIZE)) {
    return;
  }
  const message = getSizes(request);
  maybeStripPayload(request.body as Body, MAX_SIZE);
  mergeSizes(request, message);
};

export default sendReport;
